import axiosClient from './axiosClient'

const moodApi = {
  getAll: () => axiosClient.get('moods'),
}

export default moodApi